import styled from '@emotion/styled/macro';
import { FormikContextType, FormikProvider } from 'formik';
import { FC } from 'react';

import { ComposeFlex, FlexProps } from 'components/styled';

const FormComponent = styled.form<FlexProps>`
	${ComposeFlex()}
`;

type Props = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formikContext: FormikContextType<any>;
} & FlexProps;

const Form: FC<Props> = ({ formikContext, children, ...props }) => {
	return (
		<FormikProvider value={formikContext}>
			<FormComponent
				display="flex"
				flexDirection="column"
				onSubmit={formikContext.handleSubmit}
				{...props}
			>
				{children}
			</FormComponent>
		</FormikProvider>
	);
};

export default Form;
